import { useContext, useEffect, useState } from "react";
import "./seeAsWell.scss";
import { AppContext } from "../../context/AppContext";
import { I18nContext } from "../../i18n";
import Article from "../article/Article";
import { getStickyPosts } from "../../dataProvider/posts";

const SeeAsWell = () => {
  const { translate } = useContext(I18nContext);
  const [articles, setArticles] = useState([]);
  const { currentTag } = useContext(AppContext);

  useEffect(() => {
    currentTag !== undefined &&
      getStickyPosts(currentTag, 3).then((res) => setArticles(res)); // get 3 sticky post with current tag ID
  }, [currentTag]);

  return (
    <div className="see-as-well">
      <h3 className="see-as-well__title">
        {translate("seeAsWell").toUpperCase()}
      </h3>
      <div className="see-as-well__content">
        {articles.length > 0 &&
          articles.map((article, i) => {
            return (
              <Article
                key={article.id}
                title={article.title?.rendered}
                img={
                  article["_embedded"]["wp:featuredmedia"]?.[0]["source_url"]
                }
                to={article.slug}
              />
            );
          })}
      </div>
    </div>
  );
};

export default SeeAsWell;
